import React from 'react';

const GbFlag: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="84" height="56" viewBox="0 0 84 56" fill="none">
    <g clipPath="url(#clip0_47_1683)">
      <path d="M0 -3.5H84V59.5H0V-3.5Z" fill="#012169" />
      <path
        d="M9.84375 -3.5L41.8687 20.2562L73.7625 -3.5H84V4.6375L52.5 28.1312L84 51.4937V59.5H73.5L42 36.0062L10.6312 59.5H0V51.625L31.3687 28.2625L0 4.9V-3.5H9.84375Z"
        fill="white"
      />
      <path
        d="M55.65 33.3812L84 54.25V59.5L48.4312 33.3812H55.65ZM31.5 36.0062L32.2875 40.6L7.0875 59.5H0L31.5 36.0062ZM84 -3.5V-3.10625L51.3187 21.5687L51.5812 15.7937L77.4375 -3.5H84ZM0 -3.5L31.3687 19.6H23.4937L0 2.0125V-3.5Z"
        fill="#C8102E"
      />
      <path d="M31.6312 -3.5V59.5H52.6312V-3.5H31.6312ZM0 17.5V38.5H84V17.5H0Z" fill="white" />
      <path
        d="M0 21.8312V34.4312H84V21.8312H0ZM35.8312 -3.5V59.5H48.4312V-3.5H35.8312Z"
        fill="#C8102E"
      />
    </g>
    <defs>
      <clipPath id="clip0_47_1683">
        <rect width="84" height="63" fill="white" transform="translate(0 -3.5)" />
      </clipPath>
    </defs>
  </svg>
);
export default GbFlag;
